import dayjs from "dayjs";

import { PartnerCampaignFacebookPost } from "../../models/partnerCampaignFacebookPost";

export class CreateFacebookAdFromPostData {
  public postId: number;
  public addressId: number;
  public scheduledPublishDate: number;
  public isDarkPost: boolean;
  public radius: number;
  public willBecomeAd = true;
  public text: string;
  public postToFacebook: boolean;
  public postToInstagram: boolean;
  constructor(
    post: PartnerCampaignFacebookPost,
    addressId: number,
    scheduledPublishDate: Date,
    isDarkPost: boolean,
    radius: number,
    postToInstagram = false,
    postToFacebook = false,
  ) {
    this.postId = post.id;
    this.text = post.text;
    this.addressId = addressId;
    this.scheduledPublishDate = dayjs(scheduledPublishDate).unix();
    this.isDarkPost = isDarkPost;
    this.radius = radius;
    this.postToFacebook = postToFacebook;
    this.postToInstagram = postToInstagram;
  }
}
